var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "main full-height" },
    [
      _c(
        "el-container",
        [
          _c(
            "el-aside",
            { staticClass: "side-panel" },
            [_c("widget-panel", { attrs: { designer: _vm.designer } })],
            1
          ),
          _vm._v(" "),
          _c(
            "el-container",
            { staticClass: "center-layout-container" },
            [
              _c(
                "el-header",
                { staticClass: "toolbar-header" },
                [
                  _c("toolbar-panel", {
                    ref: "toolbarRef",
                    attrs: {
                      designer: _vm.designer,
                      "global-dsv": _vm.globalDsv,
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm._l(_vm.$slots, function (idx, slotName) {
                          return {
                            key: slotName,
                            fn: function () {
                              return [_vm._t(slotName)]
                            },
                            proxy: true,
                          }
                        }),
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-main",
                { staticClass: "form-widget-main" },
                [
                  _c(
                    "el-scrollbar",
                    {
                      staticClass: "container-scroll-bar",
                      style: { height: _vm.scrollerHeight },
                    },
                    [
                      _c("v-form-widget", {
                        ref: "formRef",
                        attrs: {
                          designer: _vm.designer,
                          "form-config": _vm.designer.formConfig,
                          "global-dsv": _vm.globalDsv,
                        },
                        on: { end: _vm.onEnd },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-aside",
            { staticClass: "setting-panel" },
            [
              _c("setting-panel", {
                attrs: {
                  designer: _vm.designer,
                  "selected-widget": _vm.designer.selectedWidget,
                  "form-config": _vm.designer.formConfig,
                  "global-dsv": _vm.globalDsv,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }